// Librerías
import React, { Component } from "react";
import { connect } from "react-redux";
import * as aloharFormActions from "../../store/aloharForm/actions";
import AxiosAuth from "../../services/requestApi";
import moment from "moment"; // ✅ AÑADIDO: Importar moment
import Type from "./StepsOnlyApp/Type";
import Quantities from "./StepsOnlyApp/Quantities";
import Location from "./StepsOnlyApp/Location";
import Services from "./StepsOnlyApp/Services";
import Covid from "./StepsOnlyApp/Covid";
import Photos from "./StepsOnlyApp/Photos";
import Rules from "./StepsOnlyApp/Rules";
import Guests from "./StepsOnlyApp/Guests";
import Title from "./StepsOnlyApp/Title";
import Prices from "./StepsOnlyApp/Prices";
import Payment from "./StepsOnlyApp/Payment";
import Legal from "./StepsOnlyApp/Legal";
import Calendar from "./StepsOnlyApp/Calendar";
// Componentes


class AloharFormEditOnlyApp extends Component {
  constructor(props) {
    super(props);

    if (
      parseInt(this.props.editStep) > 15 ||
      parseInt(this.props.editStep) < 3
    ) {
      window.location.href = "/";
    }

    this.props.setStep({ step: this.props.editStep });

    this.state = {
      step: parseInt(this.props.editStep),
      id: parseInt(this.props.id),
      loading: false,
      bodyParameters: {},
    };
  }

  componentWillUnmount = () => {
    // localStorage.removeItem('housingPublicProcessData')
  };

  componentDidMount = async () => {
    const step = this.state.step;
    const id = this.state.id;
    const url = `housing/public/${step - 2}/${id}`;

    this.props.housingIdSetup({ id: id });

    await AxiosAuth.get(url)
      .then((response) => {
        let bodyParameters = response.data;

        if (this.state.step === 15) {
          const newBodyParameters = bodyParameters.calendar.map((calendar) => {
            // ❌ PROBLEMA: Está agregando 2 días
            // const fixEndDate = new Date(calendar.end);
            // fixEndDate.setDate(fixEndDate.getDate() + 2);
            
            // ✅ SOLUCIÓN: No modificar la fecha original
            const fixEndDate = new Date(calendar.end);
            // NO agregar días, usar la fecha original del servidor
            
            let dd = fixEndDate.getDate();
            let mm = fixEndDate.getMonth() + 1;
            const yyyy = fixEndDate.getFullYear();

            if (dd < 10) dd = "0" + dd;
            if (mm < 10) mm = "0" + mm;

            return {
              ...calendar,
              start: moment(calendar.start).format("YYYY-MM-DD"),
              end: `${yyyy}-${mm}-${dd}`, // ✅ Usar fecha original sin modificar
            };
          });
          bodyParameters["calendar"] = newBodyParameters;
          // bodyParameters['basePrice'] = bodyParameters.basePrice
        }

        this.setState({
          bodyParameters: bodyParameters,
          loading: true,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  showStep = () => {
    const step = this.state.step;
    const bodyParameters = this.state.bodyParameters;

    switch (step) {
      case 3:
        return <Type bodyParameters={bodyParameters} modeEdit />;
      case 4:
        return <Quantities bodyParameters={bodyParameters} modeEdit />;
      case 5:
        return <Location bodyParameters={bodyParameters} modeEdit />;
      case 6:
        return <Services bodyParameters={bodyParameters} modeEdit />;
      case 7:
        return <Covid bodyParameters={bodyParameters} modeEdit />;
      case 8:
        return <Photos bodyParameters={bodyParameters} modeEdit />;
      case 9:
        return <Rules bodyParameters={bodyParameters} modeEdit />;
      case 10:
        return <Guests bodyParameters={bodyParameters} modeEdit />;
      case 11:
        return <Title bodyParameters={bodyParameters} modeEdit />;
      case 12:
        return <Prices bodyParameters={bodyParameters} modeEdit />;
      case 13:
        return <Payment bodyParameters={bodyParameters} modeEdit />;
      case 14:
        return <Legal bodyParameters={bodyParameters} modeEdit />;
      case 15:
        return <Calendar bodyParameters={bodyParameters} modeEdit />;
      default:
        window.location.href = "/";
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.state.loading ? this.showStep() : ""}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (reducers) => {
  return reducers.aloharFormReducer;
};

export default connect(mapStateToProps, aloharFormActions)(AloharFormEditOnlyApp);
